import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'Internal Feedback | Canny';
const Description =
  "Manage ideas from your internal team. Don't let their feedback get lost in the shuffle.";
const Image = 'https://canny.io/images/canny-social.png';

export default class LandingInternalFeedbackHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/use-cases/internal-feedback' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
